export const getEndpoints = environment => {
  switch (environment) {
    case 'PRODUCTION':
      return {
        AI_API: 'https://ai-api.datacamp.com'
      };
    case 'LOCAL':
    case 'TEST':
    case 'DEVELOPMENT':
    default:
      return {
        AI_API: 'https://ai-api.datacamp-staging.com'
      };
  }
};